import { Component } from '@angular/core';
import { CountryService } from '../../../api/services';
import { CountryItem } from '../../../api/models';
import { SlugifyPipe } from '../../pipes/slugify.pipe';
import { UrlService } from '../../services/url.service';

@Component({
  selector: 'app-popular',
  templateUrl: './popular.component.html',
  styleUrl: './popular.component.scss',
})
export class PopularComponent {

  country: CountryItem[] = [];
  loading = false;

  constructor(
    private countryService: CountryService,
    public url: UrlService
  ){ }

  ngOnInit(){
    this.getPopular();
  }

  getPopular(){
    this.loading = true;
    this.countryService.countryControllerGetAll({popular: true}).subscribe({
      next: (res) => {
        this.loading = false;
        const p = res.data.list;
        this.country = p.slice(0,3);
      }
    })
  }

}
